<!--suppress HtmlUnknownTag -->
<vuejs3-todo>
    Ready
</vuejs3-todo>

<template>
    <section class="maintenance-page">
        <h1>
            <template v-if="$i18n.lang === 'fr'">L'application Echoline revient très vite !</template>
            <template v-else-if="$i18n.lang === 'de'">Die Echoline-Anwendung ist bald wieder da!</template>
            <template v-else>Echoline app will be back soon!</template>
        </h1>
        <div>
            <template v-if="$i18n.lang === 'fr'">
                Nous avons momentanément coupé l'accès à notre application pour procéder à quelques changements. Revenez
                dans quelques minutes, nous n'en avons pas pour longtemps !
            </template>
            <template v-else-if="$i18n.lang === 'de'">
                Wir haben den Zugang zu unserer Anwendung kurzzeitig unterbrochen und führen einige Änderungen durch.
                Versuchen Sie es In ein paar Minuten, wir brauchen nicht lange!
            </template>
            <template v-else>
                We have closed our app momentarily to make some changes. Come back in a few minutes, it shouldn't take
                much long!
            </template>
        </div>
        <p>
            <a href="https://www.echoline.fr/" target="_blank">www.echoline.fr</a>
        </p>
    </section>
</template>

<script>
    export default {
        name: "MaintenancePage"
    }
</script>

<style lang="scss">
    @import "../../variables";
    @import "../../colors";

    .maintenance-page {
        display: flex;
        height: 100vh;
        width: 100vw;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        background-image: url("/img/outside_maintenance-page_background.svg");
        background-position: bottom center;
        background-repeat: no-repeat;
        background-size: 32%;

        h1 {
            margin: 16px 0;
            font-weight: $font-weight-bold;
        }

        div {
            background-color: $color-backdrop;
            color: white;
            width: 40%;
            margin: 0 auto;
            box-sizing: border-box;
            padding: 16px;
            border-radius: 8px;
            text-align: center;
        }

        p {
            margin: 16px 0;
        }
    }
</style>
